import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import { FaEye, FaEdit, FaTrash, FaEyeSlash } from "react-icons/fa";
import { FaKey } from "react-icons/fa";

import Search from "../../common/Search";
import { useDispatch } from "react-redux";
function ClintWiseLeadList({ lead = [],page,limit }) {
  const navigate = useNavigate();
  return (
    <div>
          <div className="main_page">
        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Lead Id</th>
                  <th> Name</th>
                  <th>Mobile No.</th>
                  <th>Source</th>
              
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {lead.length > 0 ? (
                  lead.map((item, index) => (
                    <tr key={item.id}>
                   <td>{(page - 1) * limit + index + 1}</td>
                      <td>{item.lead.id}</td>
                      <td>{item.lead?.name || "-"}</td>
                      <td>{item.lead?.mobile || "-"}</td>
                      <td></td>
                    
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No Product Found
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
            {/* {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )} */}
          </div>

        </div>
      </div>

    </div>
  );
}

export default ClintWiseLeadList;